import React from "react";
import { Outlet } from "react-router-dom";
const busComponent = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
export default busComponent
